import { type ComponentProps, type FC } from "react";
import { cn } from "@/lib/utils";

export interface ImgProps extends ComponentProps<"img"> {
  contain?: boolean;
  className?: string;
}

export const Img: FC<ImgProps> = ({ src, contain, className, style, width, height, ...props }) => {
  return (
    <img
      draggable={false}
      src={src}
      className={cn(
        "block min-h-0 max-w-full",
        contain ? "object-contain" : "object-cover",
        className,
      )}
      style={{
        width: width,
        height: height,
        ...style,
      }}
      {...props}
    />
  );
};
